import Exposure from './events/exposure';
import Click from './events/click';
import PageLeave, { type CustomData } from './events/pageLeave';
import { type App, type Directive } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

// 实例化
const exp = new Exposure();
const cli = new Click();

export const trackDirective: Directive = {
  mounted(el, binding) {
    const { arg } = binding;
    arg?.split('|').forEach((item: string) => {
      // 点击
      if (item === 'click') {
        cli.add({ el });
      } else if (item === 'exposure') {
        exp.add({ el });
      }
    });
  },
};

export function setupEventTrack(app: App) {
  app.directive('track', trackDirective);
}

/**
 * 页面停留时长统计插件
 *
 * 监听了 pageshow, pagehide, beforeunload, unload 事件
 * 在页面离开时，会将当前页面的离开时间记录
 * @returns
 * pageLeaveStart: (data?: CustomData) => void - 开始记录离开时间
 * pageLeaveEnd: () => void - 结束记录离开时间
 */
export function usePageLeave(data?: CustomData) {
  const pageLeave = new PageLeave();
  if (data) {
    pageLeave.start(data);
  }
  const events = ['pageshow', 'pagehide', 'beforeunload', 'unload'];
  const eventFuncs = events.map((item) => {
    if (item === 'pageshow') {
      return () => {
        console.log('event name is ' + item);

        pageLeave.reset();
        pageLeave.start();
      };
    } else {
      return () => {
        console.log('event name is ' + item);

        pageLeave.end();
        pageLeave.reset();
      };
    }
  });

  // 监听页面离开
  events.forEach((event, index) => {
    if (`on${event}` in window) {
      window.addEventListener(event, eventFuncs[index]);
    }
  });

  // 监听Vue页面离开
  onBeforeRouteLeave(() => {
    console.log('onBeforeUnmount');

    pageLeave.end();
    pageLeave.reset();
    events.forEach((event, index) => {
      if (`on${event}` in window) {
        window.removeEventListener(event, eventFuncs[index]);
      }
    });
  });

  return {
    pageLeaveStart: pageLeave.start.bind(pageLeave),
    pageLeaveEnd: pageLeave.end.bind(pageLeave),
  };
}
